import { lazy } from 'react';

// project imports
import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import RenderModule from 'views/RenderModule';

// sample page routing

const CreateRecord = Loadable(lazy(() => import('views/CreateRecord')));
const DocumentViewer = Loadable(lazy(() => import('views/DocumentViewer')));
const DashboardPage = Loadable(lazy(() => import('views/dashboard')));
const RecordDetailsViewer = Loadable(lazy(() => import('views/RecordDetailsViewer')));
const CatalogsOptionsGroupsPage = Loadable(lazy(() => import('views/catalogs/CatalogsOptionsGroups')));
const CatalogsMasterFinishesPage = Loadable(lazy(() => import('views/catalogs/CatalogsMasterFinishes')));
const Catalogs = Loadable(lazy(() => import('views/catalogs/Catalog')));
const SalesOrderDetailsViewer = Loadable(lazy(() => import('views/SalesOrderView')));
const PurchaseOrderDetailsViewer = Loadable(lazy(() => import('views/PurchaseOrderView')));
const DataFocusView = Loadable(lazy(() => import('views/DataFocusView')));
const DynamicPortals = Loadable(lazy(() => import('views/DynamicPortals')));
const BusinessEntities = Loadable(lazy(() => import('views/backoffice/BusinessEntities')));

const ORDERBAHN_ROUTES = [
    {
        path: 'accounting/doc-viewer/:recordTypeName?',
        element: <DocumentViewer />
    },
    {
        path: 'create-record',
        element: <CreateRecord />
    },
    {
        path: 'dashboard',
        element: <DashboardPage />
    },
    {
        path: 'catalogs',
        element: <Catalogs />
    },
    {
        path: 'options-groups',
        element: <CatalogsOptionsGroupsPage />
    },
    {
        path: 'master-finishes',
        element: <CatalogsMasterFinishesPage />
    },
    {
        path: 'data-focus-view/:recordTypeName?',
        element: <DataFocusView />
    },
    {
        path: 'record-details-viewer/:recordTypeName?',
        element: <RecordDetailsViewer />
    },
    {
        path: 'dynamic-portals/*',
        element: <DynamicPortals />
    },
    {
        path: 'sales-details-viewer/:recordTypeName?',
        element: <SalesOrderDetailsViewer />
    },
    {
        path: 'pucharse-details-viewer/:recordTypeName?',
        element: <PurchaseOrderDetailsViewer />
    },
    {
        path: 'entities',
        element: <BusinessEntities />
    },
    {
        path: '*',
        element: <RenderModule />
    }
];

const MainRoutes = {
    path: '/:tenantName',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: ORDERBAHN_ROUTES
    // IMPORTANT: This setting and also the imports below need to be restored if we want to show the Poet routes again
    // children: isPoetProject() ? POET_ROUTES : ORDERBAHN_ROUTES
};

export default MainRoutes;

// poet pages
// import { isPoetProject } from 'utils';
// import Channels from 'views/poet/Channels';
// import Settings from 'views/poet/Settings';
// const PoetProducts = Loadable(lazy(() => import('views/poet/products/index')));
// const PoetProductDetails = Loadable(lazy(() => import('views/poet/productDetails/index')));
// const PoetImportCsv = Loadable(lazy(() => import('views/poet/importCsv/index')));

// const POET_ROUTES = [
//     {
//         path: 'import',
//         element: <PoetImportCsv />
//     },
//     {
//         path: 'products/:sku',
//         element: <PoetProductDetails />
//     },
//     {
//         path: 'products',
//         element: <PoetProducts />
//     },
//     {
//         path: 'channels',
//         element: <Channels />
//     },
//     {
//         path: 'settings',
//         element: <Settings />
//     },
//     {
//         path: '*',
//         element: <div>Not found!</div>
//     }
// ];
